module.exports = __webpack_public_path__ + "img/arrow-bottom.59f5d5f8.svg";